var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.244,
    height: 32.26,
    viewBox: "0 0 30.244 32.26",
    fill: "#0a579b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(-332.8 -600)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "journal-minus",
    transform: "translate(332.8 600)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M5.5,8.508A1.008,1.008,0,0,1,6.508,7.5h8.065a1.008,1.008,0,1,1,0,2.016H6.508A1.008,1.008,0,0,1,5.5,8.508Z",
    transform: "translate(5.589 7.622)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M5.033,0H25.2a4.033,4.033,0,0,1,4.033,4.033v24.2A4.033,4.033,0,0,1,25.2,32.26H5.033A4.033,4.033,0,0,1,1,28.228V26.211H3.016v2.016a2.016,2.016,0,0,0,2.016,2.016H25.2a2.016,2.016,0,0,0,2.016-2.016V4.033A2.016,2.016,0,0,0,25.2,2.016H5.033A2.016,2.016,0,0,0,3.016,4.033V6.049H1V4.033A4.033,4.033,0,0,1,5.033,0Z",
    transform: "translate(1.016 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M2.016,6.016V5.008a1.008,1.008,0,1,1,2.016,0V6.016H5.041a1.008,1.008,0,1,1,0,2.016H1.008a1.008,1.008,0,1,1,0-2.016Zm0,6.049V11.057a1.008,1.008,0,1,1,2.016,0v1.008H5.041a1.008,1.008,0,1,1,0,2.016H1.008a1.008,1.008,0,1,1,0-2.016Zm0,6.049V17.106a1.008,1.008,0,1,1,2.016,0v1.008H5.041a1.008,1.008,0,1,1,0,2.016H1.008a1.008,1.008,0,0,1,0-2.016Z",
    transform: "translate(0 4.065)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryIcon);
export default __webpack_public_path__ + "static/media/directory-icon.bbf565bb03f85e32b665aa651face03e.svg";
export { ForwardRef as ReactComponent };